import type {App} from "crqlar-react-common/dist/models/app/app.model";
import type {OrganizationApp} from "crqlar-react-common/dist/models/app/organizationApp.model";

const normalizePath = (path: string) => (
    path.length > 1 && path.endsWith("/") ? path.slice(0, -1) : path
);

const appendRoute = (base: string, ...segments: Array<string | undefined>) => [
    normalizePath(base),
    ...segments.filter(Boolean),
].join("/");

export const buildAppLink = (app: App, orgApp: OrganizationApp) => {
    const appId = orgApp.id;

    switch (app.sku) {
        case "crm":
            return appendRoute(app.link, "daily", appId);
        case "reservations":
            return appendRoute(app.link, "calendar", appId);
        case "booking":
            return appendRoute(app.link, "configurations");
        case "marketing":
            return appendRoute(app.link, "audiences", appId);
        case "surveys":
            // Lands on the overview, the first tab for every organisation; the daily list follows it for those with stays.
            return appendRoute(app.link, "overview", appId);
        default:
            return appendRoute(app.link, appId);
    }
};
